import React, { forwardRef } from 'react';
import { styled } from '@mui/material';

import Avatar from 'shell/components/Avatar';
import Dropdown from 'shell/components/Dropdown';
import IconButton from 'shell/components/IconButton';
import ResourceChip from 'shell/components/ResourceChip';
import Stack from 'shell/components/Stack';
import Tag from 'shell/components/Tag';
import Text from 'shell/components/Text';
import { getPrettyTimestamp } from 'utils/helper';

const RootStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

const DataStack = styled(Stack)(() => {
    return {
        flex: 1,
        minWidth: 0,
    };
});

const renderFeedbackFiles = (files, getFileOptions, onSelectFile) => {
    return files.map((file) => (
        <ResourceChip
            key={file.id}
            options={getFileOptions(file)}
            resource={file}
            size={'medium'}
            type={'file'}
            onSelect={onSelectFile}
        />
    ));
};

const renderFeedbackText = (feedback) => {
    if (!feedback.active) return 'The original comment has been deleted.';
    return feedback.text;
};

const renderFeedbackTimestamp = (createdOn) => {
    return getPrettyTimestamp(createdOn);
};

export default forwardRef(
    ({ author, feedback, getFileOptions, getNameById, options, onSelect, onSelectFile, ...rest }, ref) => {
        return (
            <RootStack ref={ref} {...rest} direction={'row'} spacing={2}>
                <Avatar size={'small'} user={author} />
                <DataStack spacing={1}>
                    <Stack direction={'row'} spacing={2}>
                        {author.role === 'instructor' && <Tag type={'role'} value={'instructor'} />}
                        <Text color={'light'} variant={'p3'}>
                            {getNameById(feedback.owner_account_id)}
                        </Text>
                    </Stack>
                    {feedback.files?.length ? (
                        <Stack spacing={1}>{renderFeedbackFiles(feedback.files, getFileOptions, onSelectFile)}</Stack>
                    ) : null}
                    <Text color={feedback.active ? 'default' : 'disabled'} component={'span'} rich variant={'p3'}>
                        {renderFeedbackText(feedback)}
                    </Text>
                    {feedback.created_on !== feedback.modified_on && (
                        <Text color={'light'} component={'span'} variant={'p3'}>
                            {' '}
                            (edited)
                        </Text>
                    )}
                    <Text color={'light'} variant={'p4'}>
                        {renderFeedbackTimestamp(feedback.created_on)}
                    </Text>
                </DataStack>
                {options?.length ? (
                    <Dropdown
                        id={`dropdown-${feedback.id}`}
                        options={options}
                        rootComponent={
                            <IconButton
                                aria-label={'more feedback options'}
                                kind={'moreHorizontal'}
                                size={'small'}
                                variant={'square'}
                            />
                        }
                        onSelect={onSelect}
                    />
                ) : null}
            </RootStack>
        );
    }
);
